import pako from 'pako';
import { createLogger, LOG_NAMESPACES } from './logger';

const logger = createLogger(LOG_NAMESPACES.DATA);

export function gzipCompress(data: string): Uint8Array {
  logger.trace(`Starting gzip compression of ${data.length} characters`);
  const encoder = new TextEncoder();
  const uint8Array = encoder.encode(data);
  const result = pako.gzip(uint8Array);
  logger.trace(`Gzip compression complete: ${result.length} bytes`);
  return result;
}

export function gzipDecompress(data: Uint8Array): string {
  const decompressed = pako.ungzip(data);
  const decoder = new TextDecoder();
  return decoder.decode(decompressed);
}

export function createGzipBlob(data: Uint8Array, hash: string): File {
  const fileName = `${hash}.gz`;
  logger.trace(`Creating gzip blob: ${fileName}, size ${data.length} bytes`);
  const arrayBuffer = data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength) as ArrayBuffer;
  const file = new File([arrayBuffer], fileName, { type: 'application/gzip' });
  logger.trace(`Gzip blob created: ${fileName}, ${file.size} bytes`);
  return file;
}
